// The reset endpoint answers identically whether or not the submitted email
// resolves to an account, so nothing here may claim mail was sent, and there is
// no "account not found" response for a handler to branch on -- if you find
// yourself wanting to add one back, that is the enumeration leak returning.
import { htmlEscape } from 'escape-goat';

$(document)
  .on('ajax:error', '#new_password', (_event: JQuery.TriggeredEvent, data: JQuery.jqXHR) => {
    let errors: string;

    try {
      [errors] = JSON.parse(data.responseText).errors.email;
    } catch (e) {
      errors =
        "Oops, something went wrong on our side.  Please try again or <a href='/support'>contact us</a> for help";
    }

    $('#forgot-password-box [data-dialog-msgbox]').flashMessages({
      message: errors,
      template: window.msgboxerror,
    });
  })

  .on('ajax:success', '#new_password', () => {
    const email = htmlEscape(String($('#new_password_user_email').val() ?? ''));
    const msg =
      `If an Ably account exists for <b>${email}</b> and signs in with a password, ` +
      'reset instructions are on their way. Accounts that sign in without a password ' +
      'will not receive an email; use your usual sign-in method instead.';
    $('#forgot-password-box .js-hide-on-success').hide();
    $('#forgot-password-box .js-show-on-success').show();
    $('#forgot-password-box [data-dialog-msgbox]').flashMessages({
      message: msg,
      template: window.msgboxnotice,
    });
  })

  .on('click', '#forgot-password-box [data-close-dialog]', () => $.fancybox.close());
